import styled from 'styled-components';

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  cursor: -moz-zoom-out;
  cursor: -webkit-zoom-out;
  cursor: zoom-out;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  cursor: -moz-zoom-out;
  cursor: -webkit-zoom-out;
  cursor: zoom-out;
  width: 100%;
  max-width: 980px;
  height: 95vh;
  img {
    width: 100%;
    padding: 15px;
    background: #fff;
    object-fit: contain;
    cursor: -moz-zoom-out;
    cursor: -webkit-zoom-out;
    cursor: zoom-out;
  }

  a {
    position: absolute;
    right: 8px;
    bottom: 16px;
    height: auto !important;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 4px;
    color: #fff;
    text-decoration: none;
    font-size: 12px;
    font-weight: bold;
  }
`;
